// extracted by mini-css-extract-plugin
export var backdropBlur = "_c7-0";
export var contentCard = "_c7-5";
export var frame = "_c7-2";
export var image = "_c7-4";
export var imagePane = "_c7-3";
export var modal = "_c7-1";